class VariantSwatches extends HTMLElement {
  constructor() {
    super();
    this.productMedia = this.getProductMedia();
    this.handleSwatchClick()
  }

  getProductMedia() {
    try {
      const productMedia = this.querySelector('script[type="application/json"]').textContent;
      return JSON.parse(productMedia);
    } catch (error) {
      console.error('Error parsing product media', error);
      return [];
    }
  }

  handleSwatchClick() {
    this.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.addEventListener('change', (event) => {
        const mediaId = event.target.dataset.mediaId;
        const media = this.productMedia.find((media) => media.id == mediaId);
        this.replaceMedia(media.src);
      });
    });
  }

  replaceMedia(media) {
    if (!media) return;

    const productCardContainer = this.closest('.kc-product-card');
    const imageWrapper = productCardContainer.querySelector('.kc-product-card__image');
    const image = imageWrapper.querySelector('img');
    image.removeAttribute('srcset');

    const loadingOverlay = document.createElement('div');
    loadingOverlay.className = 'loading-overlay';
    loadingOverlay.innerHTML = `
      <div class="loading-spinner"></div>
    `;
    imageWrapper.appendChild(loadingOverlay);

    const newImage = new Image();
    newImage.onload = () => {
      image.src = media;
      loadingOverlay.remove();
    };
    newImage.onerror = () => {
      console.error('Error loading image:', media);
      loadingOverlay.remove();
    };
    newImage.src = media;
  }
}

if (!customElements.get('variant-swatches')) {
  customElements.define('variant-swatches', VariantSwatches);
}